import { CartItemData } from '@common/Checkout/shared/components/CartItem/types';
import { OrderGiftCard, OrderVoucher } from '@common/Checkout/shared/types';
import {
    Cart, CartAddItemArgs, CartItemRequestSuccessResponse,
} from '@common/Checkout/Shopcart/types';
import {
    del, get, patch, post,
} from '@common/Http';
import { ItemsParameters } from '@common/Product/AddToFavorites/types';
import {
    API_SHOPCART_CONFIG,
    API_SHOPCART_COUNT,
    API_SHOPCART_GET,
    API_SHOPCART_GIFT_CARD_APPLY,
    API_SHOPCART_GIFT_CARD_REMOVE,
    API_SHOPCART_ITEM_ADD,
    API_SHOPCART_ITEM_ADD_MULTIPLE,
    API_SHOPCART_ITEM_REMOVE,
    API_SHOPCART_ITEM_REMOVE_MULTIPLE,
    API_SHOPCART_ITEM_UPDATE,
    API_SHOPCART_VOUCHER_APPLY,
    API_SHOPCART_VOUCHER_REMOVE,
} from '@routes';

export type EanId = CartItemData['eanId'];
type Quantity = CartItemData['quantity'];
type VoucherCode = OrderVoucher['code'];
type GiftCardCode = OrderGiftCard['code'];

// Config
export function fetchConfigData(): Promise<any> { // deprecated will be removed soon
    return get(API_SHOPCART_CONFIG);
}

// Count
export function fetchShopcartCount(): Promise<{ count: number }> {
    return get(API_SHOPCART_COUNT);
}

// Shopcart
export function fetchShopcart(): Promise<Cart> {
    return get(API_SHOPCART_GET);
}

// Item
export function addShopcartItem(
    eanId: EanId,
    note?: string,
    quantity?: Quantity,
    itemsParameters?: ItemsParameters,
): Promise<CartItemRequestSuccessResponse> {
    return post(API_SHOPCART_ITEM_ADD, {
        eanId, quantity: quantity || 1, note, itemsParameters,
    });
}

export function addMultipleShopcartItem(items: CartAddItemArgs[]): Promise<CartItemRequestSuccessResponse> {
    return post(API_SHOPCART_ITEM_ADD_MULTIPLE, items);
}

export function removeShopcartItem(eanId: EanId): Promise<CartItemRequestSuccessResponse> {
    return del(API_SHOPCART_ITEM_REMOVE, { eanId });
}

export function removeMultipleShopcartItems(eansIds: string): Promise<CartItemRequestSuccessResponse> {
    return del(`${API_SHOPCART_ITEM_REMOVE_MULTIPLE}?eanIds=${eansIds}`);
}

export function updateShopcartItemQuantity(eanId: EanId, quantity: Quantity): Promise<CartItemRequestSuccessResponse> {
    return patch(API_SHOPCART_ITEM_UPDATE, { quantity, eanId });
}

// Voucher
export function applyShopcartVoucherCode(voucherCode: VoucherCode): Promise<Cart> {
    return patch(API_SHOPCART_VOUCHER_APPLY, { voucherCode });
}

export function removeShopcartVoucherCode(voucherCode: VoucherCode): Promise<Cart> {
    return patch(API_SHOPCART_VOUCHER_REMOVE, { voucherCode });
}

export function applyShopcartGiftCardCode(giftCardCode: GiftCardCode): Promise<Cart> {
    return patch(API_SHOPCART_GIFT_CARD_APPLY, { giftCardCode });
}

export function removeShopcartGiftCardCode(giftCardCode: GiftCardCode): Promise<Cart> {
    return patch(API_SHOPCART_GIFT_CARD_REMOVE, { giftCardCode });
}
